export default () => {
  const form = document.querySelector(".js-mailto-form");

  // Exit if the form is not present
  if (!form) return;

  form.addEventListener("submit", async e => {
    e.preventDefault();

    const submitButton = form.querySelector(
      'button[type="submit"], input[type="submit"]',
    );

    // Fetch client info
    let clientInfo = { ClientIp: "", UserAgent: "" };
    try {
      const response = await fetch("/api/Forms/GetClientInfo");
      if (response.ok) {
        clientInfo = await response.json();
      }
    } catch (error) {
      console.warn("Failed to fetch client info:", error);
    }

    // Build email body by processing field wrappers
    let emailBody = "";
    let currentSection = "";

    const fieldWrappers = form.querySelectorAll(".field-wrapper");

    fieldWrappers.forEach(wrapper => {
      // Check if this is a fieldset label (section header)
      if (wrapper.classList.contains("fieldset-label")) {
        const h3 = wrapper.querySelector("h3");
        if (h3) {
          currentSection = h3.textContent.trim();
          emailBody += `\n\n## ${currentSection}:\n`;
        }
      } else {
        // This is a regular field wrapper with input and label
        const label = wrapper.querySelector("label");
        const input = wrapper.querySelector("input, textarea, select");

        if (label && input) {
          const labelText = label.textContent.trim().replace(":", "");
          const inputValue = input.value || "";
          emailBody += `${labelText}: ${inputValue}\n`;
        }
      }
    });

    // Add client information at the end
    emailBody += `\n\n## Client Information:\n`;
    emailBody += `Client IP Address: ${clientInfo.ClientIp || ""}\n`;
    emailBody += `User Agent: ${clientInfo.UserAgent || ""}\n`;

    // Create mailto URL
    const mailtoUrl = `mailto:claims@stewart.com?cc=orders@stewart.com&subject=${encodeURIComponent("Consumer Title Insurance Inquiry")}&body=${encodeURIComponent(emailBody.trim())}`;

    // Open email client
    window.location.href = mailtoUrl;

    // On success: disable button and show success message
    if (submitButton) {
      submitButton.disabled = true;

      // Create success message div
      const successDiv = document.createElement("div");
      successDiv.setAttribute("role", "alert");
      successDiv.textContent =
        "Your inquiry has been successfully submitted. Please check your email client to send the message.";
      successDiv.style.marginTop = "10px";
      successDiv.style.padding = "10px";
      successDiv.style.backgroundColor = "#d4edda";
      successDiv.style.color = "#155724";
      successDiv.style.border = "1px solid #c3e6cb";
      successDiv.style.borderRadius = "4px";

      // Insert success message after the button
      submitButton.insertAdjacentElement("afterend", successDiv);
    }
  });
};
